import api from "../utils/API";

// Base URL for your API
export const stocksService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/stock", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  previewStocks: async (payload) => {
    try {
      const response = await api.post("/admin/stock/preview-upload", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  syncStocks: async (payload) => {
    try {
      const response = await api.post("/admin/stock", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  // updateStocks: async (id, payload) => {
  //   try {
  //     const response = await api.put(`/admin/stock/${id}`, payload, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //     return response.data;
  //   } catch (error) {
  //     return error.response.data;
  //   }
  // },
  // deleteStocks: async (id) => {
  //   try {
  //     const response = await api.delete(`/admin/stock/${id}`);
  //     return response.data;
  //   } catch (error) {
  //     return error.response.data;
  //   }
  // },
  // fetchStocksById: async (id) => {
  //   try {
  //     const response = await api.get(`/admin/stock/${id}`);
  //     return response.data;
  //   } catch (error) {
  //     return error.response.data;
  //   }
  // },
};
